import { useApplicationStore } from '@data';
import {
  Button,
  Checkbox,
  Field,
  Label,
  Paragraph,
  Switch,
} from '@quickmd-llc/design-system';

export function FlagsSection() {
  const experimentCuratedAppointmentSlots = useApplicationStore(
    ({ flags }) => flags.experimentCuratedAppointmentSlots,
  );
  const experimentCuratedAppointmentSlotsEnabled = useApplicationStore(
    ({ flags }) => flags.experimentCuratedAppointmentSlotsEnabled,
  );
  const experimentMatQuestions = useApplicationStore(
    ({ flags }) => flags.experimentMatQuestions,
  );
  const experimentMatQuestionsEnabled = useApplicationStore(
    ({ flags }) => flags.experimentMatQuestionsEnabled,
  );
  const flagsHaveBeenFetched = useApplicationStore(
    ({ flags }) => flags.flagsHaveBeenFetched,
  );
  const setFlags = useApplicationStore(({ flags }) => flags.setFlags);

  if (!flagsHaveBeenFetched) {
    return null;
  }

  function handleChange(enabled: boolean) {
    setFlags({
      experimentCuratedAppointmentSlots: enabled,
    });
  }

  function handleMatVariantChange(enabled: boolean) {
    setFlags({
      experimentMatQuestions: enabled,
    });
  }

  function handleMatEnabledChange(enabled: boolean) {
    setFlags({
      experimentMatQuestionsEnabled: enabled,
    });
  }

  async function handleClick() {
    const dbs = await indexedDB.databases();

    await Promise.all(
      dbs
        .filter((db) => db.name?.includes('firebase'))
        .map((db) => db.name && indexedDB.deleteDatabase(db.name)),
    );

    window.location.reload();
  }

  return (
    <div>
      <Paragraph size="xs" className="mb-1 font-semibold">
        Flags
      </Paragraph>

      <div className="mb-sp-2 grid grid-cols-2 gap-sp-1">
        <Field className="grid gap-sp-0.5">
          <Label size="sm">Experiment Appointment Slots Enabled</Label>
          <Checkbox
            checked={experimentCuratedAppointmentSlotsEnabled}
            disabled
          />
        </Field>

        <Field data-testid={`pw_devTools_cro`} className="grid gap-sp-0.5">
          <Label size="sm">Experiment Appointment Slots Variant</Label>

          <div className="flex items-center gap-sp-1">
            <Switch
              data-testid="pw_devTools_cro_switch"
              checked={experimentCuratedAppointmentSlots}
              disabled={!experimentCuratedAppointmentSlotsEnabled}
              onChange={handleChange}
            />

            <Paragraph size="xs">
              {experimentCuratedAppointmentSlots ? 'Treatment' : 'Control'}
            </Paragraph>
          </div>
        </Field>

        <Field className="grid gap-sp-0.5">
          <Label size="sm">Experiment MAT Questions Enabled</Label>
          <Switch
            data-testid="pw_devTools_mat_enabled_switch"
            checked={experimentMatQuestionsEnabled}
            onChange={handleMatEnabledChange}
          />
        </Field>

        <Field data-testid="pw_devTools_mat" className="grid gap-sp-0.5">
          <Label size="sm">Experiment MAT Questions Variant</Label>

          <div className="flex items-center gap-sp-1">
            <Switch
              data-testid="pw_devTools_mat_switch"
              checked={experimentMatQuestions}
              disabled={!experimentMatQuestionsEnabled}
              onChange={handleMatVariantChange}
            />

            <Paragraph size="xs">
              {experimentMatQuestions ? 'Treatment' : 'Control'}
            </Paragraph>
          </div>
        </Field>
      </div>

      <Button priority="secondary" onClick={handleClick} size="s">
        Clear Remote Config
      </Button>
    </div>
  );
}
